import { GiftCard } from "stores/primitives/gift-card"

export const getDuplicateGiftCodes = (cards: GiftCard[]): { duplicateKeys: Set<string>; duplicateCount: number } => {
  const keyCounts = new Map<string, number>()
  cards.forEach(item => {
    const key = item.giftCode
    if (!key) return
    keyCounts.set(key, (keyCounts.get(key) || 0) + 1)
  })
  const duplicateKeys = new Set<string>()
  keyCounts.forEach((count, key) => {
    if (count > 1) duplicateKeys.add(key)
  })
  const duplicateCount = cards.filter(item => duplicateKeys.has(item.giftCode)).length

  return { duplicateKeys, duplicateCount }
}
